import { render, staticRenderFns } from "./ActivateTeletag.vue?vue&type=template&id=7850d164"
import script from "./ActivateTeletag.vue?vue&type=script&lang=js"
export * from "./ActivateTeletag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports